import React, { useState, useEffect, useRef } from 'react';
import { LabelField } from './Appointment.style';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelExport } from '../../services/excelExport.service';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Appointment
Description : Pagina de Appointment para el CRUD de los cargos del aplicativo remunerlite.
Date Autor Modification
================================================================================
13/10/2021 Cristian Andres Pizo Mina - Pagina de Cargo
05/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */

export default function Appointment() {

  //#region VARIABLES
  const toast = useRef(null);
  const [name, setName] = useState("");
  const [area, setArea] = useState("");
  const [code, setCode] = useState("");
  const [job_id, setJob_id] = useState("");
  const [updateName, setUpdateName] = useState("");
  const [updateArea, setUpdateArea] = useState("");
  const [updateCode, setUpdateCode] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpen_, setIsOpen_] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
  const [rowData, setRowData] = useState([]);
  const [rowDataExport, setRowDataExport] = useState([]);
  const headers = { authorization: localStorage.getItem('token') };
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadPage, setLoadPage] = useState(false)
  const [loading2, setLoading2] = useState(false);

  // inicializacion de tabla
  useEffect(() => {
    setTabla()
  }, []);

  // mostrar modal  de crear
  const showModal = () => {
    setIsOpen(true);
  };

  // cerrar modal  de crear
  const hideModal = () => {
    setIsOpen(false);
  };

  // mostrar modal  de actualizar
  const showModal_ = () => {
    setIsOpen_(true);
  };

  // cerrar modal  de actualizar
  const hideModal_ = () => {
    setIsOpen_(false)
  };

  // mostrar modal  de eliminar y guardar id de la fila
  const showModalEliminar = (JOB_ID) => {
    setDeleteId(JOB_ID);
    setIsOpenEliminar(true);
  };

  // cerrar modal  de eliminar
  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  // inicializacion de constantes
  function inizilaizarData(rowData) {
    setUpdateName(rowData.NAME)
    setUpdateArea(rowData.AREA)
    setJob_id(rowData.JOB_ID)
    setUpdateCode(rowData.CODE)
    showModal_();
  }

  // limpiar campos
  async function limpiar() {
    setName("");
    setArea("");
    setCode("");
    setJob_id("");
  }

  // validar campos vacios
  function validar() {
    if (name == "") {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar nombre del cargo', life: 4000 });
      return false
    } if (area == "") {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar Area', life: 4000 });
      return false
    }

    return true
  }

  // inicializacion de tabla
  async function setTabla() {
    await apis.getJobs(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
      if (res.data["JOBS"].length > 0) {
        let data = res.data["JOBS"]
        let exportData = []
        data.forEach(job => {
          let _job = {
            'Id Cargo': job.JOB_ID,
            'Código del cargo': job.CODE,
            'Área del cargo': job.AREA,
            'Nombre del cargo': job.NAME
          }
          exportData.push(_job)
        })
        setRowDataExport(exportData)
        setRowData(data)
        setLoadPage(true)
      } else {
        setRowData([])
        setRowDataExport([])
        setLoadPage(true)
      }
    }).catch(err => {
      setLoadPage(true)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })
  }

  // crear cargo
  async function completarRegistro() {
    if (validar()) {
      setLoadingCreate(true)
      const _name = name;
      const _area = area;
      const _code = code;
      const _cliente = localStorage.getItem('client')
      const _entity = localStorage.getItem('entity')
      const job = {
        CLIENT: _cliente,
        ENTITY: _entity,
        NAME: _name,
        AREA: _area,
        CODE: _code
      }
      await apis.postJobs(job, headers).then(res => {
        setLoadingCreate(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Cargo agregado exitosamente', life: 4000 });
        hideModal();
        setTabla();
        limpiar();
      }).catch(err => {
        setLoadingCreate(false)
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
  }

  // actualizar cargo
  async function actualizar() {
    setLoadingUpdate(true)
    const _job_id = job_id;
    const _job_name = updateName;
    const _area = updateArea;
    const _code = updateCode;
    const _client = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')

    const job = {
      CLIENT: _client,
      ENTITY: _entity,
      NAME: _job_name,
      AREA: _area,
      CODE: _code,
      JOB_ID: _job_id
    }

    await apis.putJobs(job, headers).then(res => {
      setLoadingUpdate(false)
      setIsOpen_(false);
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Registro actualizado exitosamente', life: 4000 });
    }).catch(err => {
      setLoadingUpdate(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })
    setTabla();
  }

  // eliminar cargo
  async function eliminar() {
    setLoadingDelete(true)
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _job_id = deleteId;

    await apis.deleteJobs(_entity, _cliente, _job_id, headers).then(res => {
      setLoadingDelete(false)
      setIsOpenEliminar(false)
      toast.current.show({ severity: 'info', summary: 'Éxito', detail: 'Cargo eliminado', life: 4000 });
    }).catch(err => {
      setLoadingDelete(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })

    setTabla();
  }

  const exportExcel = () => {
    excelExport(rowDataExport, 'Cargos');
    setLoading2(false);
  }

  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton Agregar Persona izquierda de la tabla
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={showModal} />
      </React.Fragment>
    )
  }

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button type="button" disabled={rowData.length === 0} icon="pi pi-file-excel" label="Exportar" loading={loading2} onClick={() => { setLoading2(true); exportExcel() }} className="p-button-success mr-2" data-pr-tooltip="XLS" />
      </React.Fragment>
    )
  }

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex">
        <Button icon="pi pi-pencil" className="p-button-warning  p-button-sm text-xs mr-2" tooltip="Editar Cargo" tooltipOptions={{ position: 'top' }} onClick={() => { inizilaizarData(rowData) }} />
        <Button icon="pi pi-trash" className="p-button-danger  p-button-sm text-xs" tooltip="Eliminar cargo" tooltipOptions={{ position: 'top' }} onClick={() => { showModalEliminar(rowData.JOB_ID) }} />
      </div>
    )
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
        </IconField>
      </div>
    )
  }




  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'JOB_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'AREA': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CODE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  // Pie de pagina modal de crear cargo
  const addFooter = (
    <div>
      <Button onClick={hideModal}>Cancelar</Button>
      <Button onClick={completarRegistro} label='Guardar' loading={loadingCreate}></Button>
    </div>
  );

  // cabezera de modal crear cargo
  const addHeader = (
    <div>
      <h3>Agregar Cargo</h3>
    </div>
  );

  // Pie de pagina modal de editar cargo
  const updateFooter = (
    <div>
      <Button onClick={hideModal_}>Cancelar</Button>
      <Button onClick={actualizar} label='Guardar' loading={loadingUpdate}></Button>
    </div>
  );

  // cabezera de modal editar cargo
  const updateHeader = (
    <div>
      <h3>Actualizar el cargo</h3>
    </div>
  );

  // Pie de pagina modal de eliminar cargo
  const deleteFooter = (
    <div>
      <Button onClick={hideModalEliminar}>Cancelar</Button>
      <Button onClick={eliminar} label='Si' loading={loadingDelete}></Button>
    </div>
  );

  // cabezera de modal eliminar cargo
  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar el cargo?</h3>
    </div>
  );

  // Return que entrega la pantalla
  return (

    <div className=''>
      <Toast ref={toast} />
      <div className="font-bold text-4xl pt-5">
        <span className="text-900 mt-8">Cargos</span>
      </div>
      <div className="surface-100	 px-4 py-2 md:px-6 lg:px-8">

        <Dialog header={addHeader} footer={addFooter} visible={isOpen} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <LabelField htmlFor="label">Código cargo</LabelField>
          <InputText style={{ width: "20rem" }} value={code} onChange={(e) => setCode(e.target.value)} placeholder="Código cargo" />
          <LabelField htmlFor="label">Área del cargo</LabelField>
          <InputText style={{ width: "20rem" }} value={area} onChange={(e) => setArea(e.target.value)} placeholder="Área" />
          <LabelField htmlFor="label">Nombre del cargo</LabelField>
          <InputText style={{ width: "20rem" }} value={name} onChange={(e) => setName(e.target.value)} placeholder="Cargo" />
        </Dialog>

        <Dialog header={updateHeader} footer={updateFooter} visible={isOpen_} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal_} >
          <LabelField htmlFor="label">Código cargo</LabelField>
          <InputText style={{ width: "20rem" }} value={updateCode} onChange={(e) => setUpdateCode(e.target.value)} placeholder="Código cargo" />
          <LabelField htmlFor="label">Área del cargo</LabelField>
          <InputText style={{ width: "20rem" }} value={updateArea} onChange={(e) => setUpdateArea(e.target.value)} placeholder="Área" />
          <LabelField htmlFor="label">Nombre del cargo</LabelField>
          <InputText style={{ width: "20rem" }} value={updateName} onChange={(e) => setUpdateName(e.target.value)} placeholder="Cargo" />
        </Dialog>

        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>

        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate} end={rightToolbarTemplate} />
            <DataTable className="text-xs" value={rowData} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              scrollHeight="flex" selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="JOB_ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['JOB_ID', 'AREA', 'NAME', 'CODE']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="JOB_ID" header="Id Cargo" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
              <Column field="CODE" header="Código del cargo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Llave única" sortable></Column>
              <Column field="AREA" header="Área del cargo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
              <Column field="NAME" header="Nombre del cargo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '50px', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>
      </div>
    </div>
  );
}